import { gql } from "@apollo/client"

const INSTRUCTION_JOB_STEP_FIELDS = gql`
  fragment InstructionJobStepFields on InstructionJobStep {
    id
    step
    section
    name
    description
    responseType
    notApplicable
    uploads {
      ...JobStepUploadsFields
    }
  }
`

export { INSTRUCTION_JOB_STEP_FIELDS }
